import React from 'react';
import * as H1 from '../Helper/H1';
import Send from '../Helper/Send';
import { NavLink, useParams, useNavigate } from 'react-router-dom';
import $ from "jquery";
import { Form,Placeholder, Animation, Progress, Button } from 'rsuite';



function withParams(Component) {
    return props => <Component {...props} params={useParams()} navigation={useNavigate()} />;
}

export  class Profile extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
                load : true,
                theme: localStorage.getItem('theme'),
        };
    }


    // ---------------- componentDidMount--------------------------
    componentDidMount() {

        let params = this.props.params;

        if(params && params.stus  == 'reload'){
            this.setState({ load: null });
    
            Send('user/token', null, false).then((res) => {
                H1.new_token(res.data.token);
                window.location.href = "/profile";
            }).catch((err) => {});
        }
    }

    // ---------------- singout--------------------------
    singout() {
        localStorage.clear();
        window.location.reload(true);
    }



   // data-theme-version="dark" class="rs-theme-dark"
    

    /* ------------------------------ theme_switch  ------------------------------ */
    theme_switch = (e) => {

        if (this.state.theme === 'dark') {
            localStorage.setItem('theme', 'light')
            this.setState({ theme: 'light' });
            $('body').attr('data-theme-version', 'light').removeClass('rs-theme-dark').addClass('rs-theme-light');
        }
        else {
            localStorage.setItem('theme', 'dark')
            this.setState({ theme: 'dark' });
            $('body').attr('data-theme-version', 'dark').removeClass('rs-theme-light').addClass('rs-theme-dark');
        }

    }



    


    render() {

        H1.page_name("حساب کاربری");



        return this.state.load && (


            <div className="h-100 mt-4">

                <div className='c-row'>

        
                    <div className="text-center mb-2 py-2 position-relative">

                        <span className="fs-3 position-absolute top-50 start-0 translate-middle-y" onClick={this.theme_switch}>
                            
                                 {this.state.theme === 'light' ?
                                           <img src='/img/icon/moon.svg' width={20}/>
                                           
                                           :                      
                                            <img src='/img/icon/sun.svg' width={20}/>

                                       }
                        </span> 
                        <span className='fs-6'>حساب کاربری</span>

                    </div>
     

                </div>

        



                <div className="c-row text-center mt-4">
                    <Animation.Slide in={true} placement="right">
                        <img src={localStorage.getItem('avatar')} width="85" height="85" className='rounded-50 rounded-circle' />
                    </Animation.Slide>
                    <Animation.Slide in={true} placement="top">
                        <div>

                            <div className='fs-5 fs-18 mt-3'>{localStorage.getItem("name")}</div>
                            <NavLink className='cc-1 mt-1 fs-12' exact="true" to='/profile/edit'> ویرایش حساب </NavLink>

                        </div>

                    </Animation.Slide>
                </div>




                <div className="c-row text-center mt-4">


               
                <Form readOnly={true}  checkTrigger='none' noValidate={true} align="middle" >

                    <Form.Group controlId="discode" className='position-relative'>
                        
                        <Form.Control name="discode" type="text" className={`esh-dark p-3 in_s1 text-start ${H1.SubCount() ? 'bb-yellow' : ' bb-2'}`} defaultValue={ H1.SubCount() ?  "اشتراک ویژه" + ':   ' + H1.SubCount() +  ' روز' : 'اشتراک ویژه ندارید'} />
                        <NavLink exact="true" to='/cart/sub'> <Button className='buy_sub_btn cc-1' appearance="default" type="submit" loading={this.state.loader_1}> تمدید <span className="icon-Add-Basket"></span></Button> </NavLink>
                    </Form.Group>

                </Form>


                </div>





                <div className="c-row text-center mt-5">

                <NavLink exact="true" to='/profile/transaction' className='cc-3'>
                  <div className="d-flex flex-row px-2">

                       <div className='me-3'>
                         <span className="icon-History fs-3"></span>
                        </div>

                        <div className='me-3  fs-16'>
                             تاریخچه پرداخت ها
                        </div>

                        <div className='ms-auto'>
                         <span className="icon-Right rotate-180 fs-16"></span>

                        </div>

                  </div>
                  </NavLink>

                </div>



                <div className="c-row text-center mt-5">
                   
                  <a href="https://wa.me/989305759505" target="_blank" rel="noopener noreferrer">  <Button appearance="ghost" color='green' > پشتیبانی واتساپ </Button> </a>

                  <br/>
                
                   <NavLink reloadDocument to='/profile/token/reload'>  <Button className='mt-4' appearance="ghost" color='blue' > بروزرسانی اطلاعات <span className="icon-Reload"></span></Button> </NavLink>
                    <br/>
                   <Button className='mt-4' appearance="ghost" color='red' onClick={() => this.singout()} > خروج از حساب <span className="icon-Add-Basket"></span></Button>



                </div>

            </div>


        )
    }
}

export default withParams(Profile);
